module.exports = __webpack_public_path__ + "img/1.8dcf31b0.png";